import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import config from '../../config.js'
import Staff from '../model/instance/Staff.js'

Vue.use(Vuex)

const addLoading = (state) => {
  Vue.set(state,'is_loading',true)
  var que;
  do {
    que = Math.floor((Math.random() * 1000000) + 1);
  } while(state.loading_que.includes(que))
  state.loading_que.push(que)
  return que
}

const finishLoading = (state,que) => {
  state.loading_que.splice(state.loading_que.indexOf(que), 1);
  if(state.loading_que.length == 0){
    Vue.set(state,'is_loading',false)
  }
}



const getStationList = (state) => {
  if(state.station_list!=null && state.station_list!=undefined) {
    return Promise.resolve(state.station_list)
  }else{
    var que = addLoading(state)
    return axios
    .post(config.api.url.manage.station.get_stationlist,{},{ headers: Staff.getTokenHeader()})
    .then(response => {
      finishLoading(state,que)
      state.station_list = response.data.stationlist;
      return state.station_list;
    })
  }
}

const getStationCode = (state) => {
  if(state.select_station_code!=null && state.select_station_code!=undefined) {
    return Promise.resolve(state.select_station_code)
  }else{
    return getStationList(state)
    .then(station_list=>{
      state.select_station_code = station_list[0].station_code
      return state.select_station_code
    })
  }
}

export default new Vuex.Store({
  state: {
    to_name : 'Appointment_List_0'

    ,is_loading : false
    ,loading_que : []

    ,station_list : null

    ,select_station_code : null
    
  },
  getters: {
    getStationList : getStationList,
    getStationCode : getStationCode
  },
  mutations: {
    setToName(state,name){state.to_name = name}
    ,addLoading : addLoading
    ,finishLoading : finishLoading
    ,clearLoading(state){state.loading_que = [];Vue.set(state,'is_loading',false)}
    ,resetStationList(state){state.station_list=null}
  },
  actions: {

  },
  modules: {
    
  }
})
